const External = () => (
  <>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M6.5 5A1.5 1.5 0 0 0 5 6.5v11A1.5 1.5 0 0 0 6.5 19h11a1.5 1.5 0 0 0 1.5-1.5V13a.5.5 0 0 1 1 0v4.5a2.5 2.5 0 0 1-2.5 2.5h-11A2.5 2.5 0 0 1 4 17.5v-11A2.5 2.5 0 0 1 6.5 4H11a.5.5 0 0 1 0 1z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M12.092 12.616a.5.5 0 0 1-.344.15.47.47 0 0 1-.364-.15.5.5 0 0 1-.159-.354.5.5 0 0 1 .16-.354L18.292 5H14.5a.48.48 0 0 1-.357-.143A.48.48 0 0 1 14 4.5q0-.213.143-.357A.48.48 0 0 1 14.5 4h4.692a.784.784 0 0 1 .808.808V9.5a.48.48 0 0 1-.143.357.48.48 0 0 1-.357.143.48.48 0 0 1-.357-.143A.48.48 0 0 1 19 9.5V5.708z"
    />
  </>
)
export default External
